import React from 'react';
import './styles.scoped.css';

const EdgeMenuItem = ({ text, onPress, description, disabled }) => (
  <div className="menu-item" style={disabled ? { opacity: '0.3' } : {}} onClick={() => !disabled && onPress()}>
    <div className="text-wrapper">
      <span className="title-text">{text}</span>
    </div>
  </div>
);

export default EdgeMenuItem;
